export default __webpack_public_path__ + "static/media/available.a3b21164.svg";